<template>
    <a-card>
        <span slot="title">
            <i class="fa fa-line-chart"></i>Lists Growth

            <div class="float-right">
                <template v-if="loading">
                    <Stretch></Stretch>
                </template>
                <template v-else>
                    <div class="row">
                        <div class="col-md-4 pull-right">
                           <a-select v-model="timeInterval" >
                              <a-select-option value="last_7_days">Last 7 days</a-select-option>
                              <a-select-option  value="last_30_days">Last 30 days</a-select-option >
                              <a-select-option  value="last_60_days">Last 60 days</a-select-option >
                              <a-select-option  value="last_90_days">Last 90 days</a-select-option >
                              <a-select-option  value="last_year">Last year</a-select-option >
                           </a-select>
                           <a-divider type="vertical" />
                           <a-button type="primary" icon="reload" @click.preent="refresh">
                            Refresh
                           </a-button>
                        </div>
                    </div>
                </template>

            </div>
        </span>

        <div class="plot-container d-flex">
            <div class="plot-stage">
                <canvas width="1000px" height="330px" ref="listGrowthGraph"></canvas>
            </div>
        </div>
    </a-card>
</template>

<script>
    import Api from "@/services/Api.js";
    import Chart from 'chart.js';
    import _ from 'lodash';
    import { Stretch } from 'vue-loading-spinner';
    import moment from "moment";
    const dateArray = require('moment-array-dates');

    export default {
        components: {Stretch},
        data() {
            return {
              timeInterval: 'last_7_days',
              range: [],
              chart: null,
              data: {
                subscribed: [0],
                unsubscribed: [0]
              },
              loading: false
            };
        },


        computed: {
            dateRanges() {
                return dateArray.range(this.dateRange.from, this.dateRange.to, 'YYYY-MM-DD', true);
            },
            dateRange() {
                return this.getDateRange(this.timeInterval);
            },
            labels() {
                return this.dateRanges.map((date) => {
                    return moment(date, 'YYYY-MM-DD').format('DD/MM');
                });
            }
        },

        methods: {
            regenerateChart() {
                const ctx = this.$refs.listGrowthGraph.getContext('2d');
                /* eslint-disable no-new */
                this.chart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: this.labels,
                        datasets: [
                            {
                                label: 'Unsubscribed',
                                backgroundColor: '#f6b26b',
                                data: this.data.unsubscribed
                            },
                            {
                                label: 'Subscribed',
                                backgroundColor: '#93c47d',
                                data: this.data.subscribed
                            }
                        ]
                    },
                    options: {
                        title: {
                            display: false
                        },
                        legend: {
                            display: false
                        },
                        tooltips: {
                            mode: 'index',
                            intersect: false
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                                {
                                    stacked: true,
                                    gridLines: {
                                        display: false,
                                        drawBorder: true,
                                        drawTicks: true
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    stacked: true,
                                    gridLines: {
                                        display: true,
                                        drawBorder: false,
                                        drawTicks: true
                                    },
                                    ticks: {
                                        min: 0
                                    }
                                }
                            ]
                        }
                    }
                });
            },

            getDateRange(interval) {
                const format = 'YYYY-MM-DD';
                let from = '';
                let to = moment();

                const year = 1;
                const eightyNine = 89;
                const fiftyNine = 59;
                const twentyNine = 29;
                const six = 6;

                switch (interval) {
                    case 'last_year':
                        from = moment().subtract(year, 'year').startOf('year');
                        to = moment().subtract(year, 'year').endOf('year');
                        break;

                    case 'last_90_days':
                        from = moment().subtract(eightyNine, 'days');
                        break;

                    case 'last_60_days':
                        from = moment().subtract(fiftyNine, 'days');
                        break;

                    case 'last_30_days':
                        from = moment().subtract(twentyNine, 'days');
                        break;

                    case 'last_7_days':
                        from = moment().subtract(six, 'days');
                        break;

                    default:
                        from = moment().subtract(six, 'days');
                        break;
                }

                return {
                    from: from.format(format),
                    to: to.format(format)
                };
            },

            fetchData(interval, refresh = false) {
                this.loading = true;
                const range = this.getDateRange(interval);

                if (refresh) {
                    range.refresh = 1;
                }

                Api.get(`sites/${this.$route.params.siteId}/overview/lists-growth?from=` + range.from + '&to=' + range.to).then(response => {
                    if (this.chart) {
                        this.chart.destroy();
                    }
                    this.loading = false;
                    this.data = this.formatData(response.data);

                    this.regenerateChart();
                });
            },
            formatData(data) {
                const datasets = {
                    subscribed: [],
                    unsubscribed: []
                };

                data = data.sort((a, b) => {
                    return new Date(a.created_at) - new Date(b.created_at);
                });

                data = _.keyBy(data, 'created_at');
                let prev = 0;

                this.dateRanges.forEach((date) => {
                    const singleData = data[date];

                    if (singleData) {
                        datasets.subscribed.push(singleData.total_subscribe);
                        datasets.unsubscribed.push(singleData.total_unsubscribe);
                        prev = singleData.total_subscribe;
                    } else {
                        datasets.subscribed.push(prev);
                        datasets.unsubscribed.push(0);
                    }
                });

                return datasets;
            },
            refresh() {
                this.fetchData(this.timeInterval, true);
            }
        },

        mounted() {
            this.fetchData(this.timeInterval);
        },

        watch: {
            timeInterval(value) {
                this.fetchData(value);
            }
        }
    };
</script>

<style>
    .lists-growth-plot {
        margin-bottom: 30px;
    }

    .select {
        width: 140px;
        height: 30px;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAh0lEQVQ4T93TMQrCUAzG8V9x8QziiYSuXdzFC7h4AcELOPQAdXYovZCHEATlgQV5GFTe1ozJlz/kS1IpjKqw3wQBVyy++JI0y1GTe7DCBbMAckeNIQKk/BanALBB+16LtnDELoMcsM/BESDlz2heDR3WePwKSLo5eoxz3z6NNcFD+vu3ij14Aqz/DxGbKB7CAAAAAElFTkSuQmCC) !important;
        background-repeat: no-repeat;
        background-position: 110px center;
        border-radius: 0;
        -webkit-appearance: none;

        &:focus {
            outline: none;
        }
    }

    select:focus {
        outline: none;
    }
</style>